module.exports = __webpack_public_path__ + "img/unknown-user.31ed8dae.png";